/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a UUID or ULID to validate it and read its details — version, variant, and the embedded timestamp where one exists. Everything runs in your browser.`)
};

const es_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega un UUID o ULID para validarlo y leer sus detalles — versión, variante y la marca de tiempo incorporada si existe. Todo se ejecuta en tu navegador.`)
};

const de_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine UUID oder ULID ein, um sie zu validieren und ihre Details abzulesen — Version, Variante und den eingebetteten Zeitstempel, sofern vorhanden. Alles läuft direkt in Ihrem Browser.`)
};

const nl_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een UUID of ULID om deze te valideren en lees de details — versie, variant en de ingebouwde tijdstempel waar aanwezig. Alles werkt in je browser.`)
};

const fr_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez un UUID ou un ULID pour le valider et lire ses détails — version, variante, et l'horodatage intégré le cas échéant. Tout s'exécute dans votre navigateur.`)
};

const it_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un UUID o un ULID per convalidarlo e leggerne i dettagli — versione, variante, e il timestamp incorporato se esiste. Tutto viene eseguito nel tuo browser.`)
};

const pt_br2_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um UUID ou ULID para validá-lo e ler seus detalhes — versão, variante, e o timestamp incorporado onde existe um. Tudo funciona no seu navegador.`)
};

const pt_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um UUID ou ULID para o validar e ler os seus detalhes — versão, variante e o timestamp incorporado, se existir. Tudo funciona no seu navegador.`)
};

const ja_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID または ULID を貼り付けて検証し、その詳細を読み取ります — バージョン、バリアント、および存在する場合は埋め込みタイムスタンプ。すべてブラウザで実行されます。`)
};

const zh_ud_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴一个 UUID 或 ULID 以验证它并查看其详细信息——版本、变体,以及内嵌的时间戳(如果存在)。一切都在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_intro", locale)
	if (locale === "en") return en_ud_intro(inputs)
	if (locale === "es") return es_ud_intro(inputs)
	if (locale === "de") return de_ud_intro(inputs)
	if (locale === "nl") return nl_ud_intro(inputs)
	if (locale === "fr") return fr_ud_intro(inputs)
	if (locale === "it") return it_ud_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ud_intro(inputs)
	if (locale === "pt") return pt_ud_intro(inputs)
	if (locale === "ja") return ja_ud_intro(inputs)
	return zh_ud_intro(inputs)
};